import { Outlet, useLocation } from 'react-router-dom';
import DashboardLayout from '@/layouts/DashboardLayout';

export default function DashboardLayoutWrapper() {
  const location = useLocation();

  // Determine the current view based on the pathname
  const getCurrentView = () => {
    const path = location.pathname;

    if (path.startsWith('/products-management')) {
      if (path.endsWith('/new') || path.includes('/edit')) {
        return 'product-edit';
      } else if (path.endsWith('/bulk')) {
        return 'bulk-product-add';
      } else if (path.split('/').length > 2) {
        return 'product-detail';
      }
      return 'products';
    }

    if (path.startsWith('/user-management')) {
      if (path.endsWith('/add')) {
        return 'user-add';
      } else if (path.includes('/edit/')) {
        return 'user-edit';
      } else if (path.split('/').length > 2) {
        return 'user-detail';
      }
      return 'users';
    }

    if (path.startsWith('/branch-management')) {
      return 'branches';
    }

    if (path.startsWith('/showroom')) {
      return path.includes('analysis') ? 'analysis-detail' : 'showroom';
    }

    if (path.startsWith('/chat')) {
      return 'chat';
    }

    if (path.startsWith('/integration')) {
      return 'integration';
    }

    if (path.startsWith('/profile')) {
      return 'profile';
    }

    // Default to dashboard
    return 'dashboard';
  };

  return (
    <DashboardLayout currentView={getCurrentView()}>
      <Outlet />
    </DashboardLayout>
  );
}
